<template>
  <div>
    <div class="media-drop d-flex justify-content-between" @drop="dropItem" @dragover.prevent>
      <p v-if="item != undefined" class="overflow-hidden h-100 col-9 p-0 m-0"><small>{{ item.name }}</small></p>
      <span v-if="item != undefined" class="col-3 p-0 m-0 text-right">
        <a class="text-primary mr-1" href="#" @click.prevent><i class="fa fa-eye"></i></a>
        <a class="text-danger" href="#" @click.prevent="removeItem"><i class="fa fa-trash"></i></a>
      </span>

      <div style="margin-top:-3px;margin-left:-5px">
        <button
          v-if="!item"
          class="btn btn-sm btn-dark"
          @click="toggleSearch"
        >
          <i class="fa fa-search"></i>
        </button>
      </div>
      <div v-if="!item" class="px-4 media-drop"  @drop="dropItem" @dragover.prevent>
        <p class="text-center">Arrastar Midia</p>
      </div>
    </div>
    <div
      v-if="searchMedia"
      class="border position-absolute py-2 px-2"
      :style="{
        'width': '100%',
        'margin-left': '-13px',
        'margin-top': '-10px',
        'height': '300px',
        'background': 'white',
        'z-index': 10,
        'overflow-y': 'auto',
        'border-radius': '5px'
      }"
    >
      <p class="mb-0">Midias na Biblioteca</p>
      <input
        type="text"
        class="form-control form-control-sm"
        placeholder="Buscar..."
        v-model="filter"
        @keyup="loadLibrary()"
      />
      <medias
        v-for="item in items"
        :item="item" :key="item.id"
        :draggable="false"
        @reload="loadLibrary"
        @selectMedia="selectMedia"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Axios from 'axios'
import Medias from './Medias'

export default {
  components: {
    "medias": Medias
  },
  props: {
    type: {
      required: false,
      default: ['video'],
      type: Array
    },
    media: {
      required: false
    }
  },
  data () {
    return {
      searchMedia: false,
      item: undefined,
      items: [],
      filter: ''
    }
  },
  computed: {
    ...mapGetters({
      dragging: 'getDragging',
      currentUser: 'getCurrentUser'
    })
  },
  methods: {
    ...mapActions({
      setDragging: 'setDragging'
    }),

    toggleSearch: function () {
      // toggleSearch
      this.searchMedia = !this.searchMedia
      this.loadLibrary()
    },

    loadLibrary: function () {
      Axios.get(`/teacher/library/${ this.currentUser.id }/items?name=${ this.filter }`)
        .then( res => {
          this.items = res.data.data
        })
    },

    selectMedia: function (item) {
      if ( this.type ) {
        let type = item.type.split('/')[0]
        if(!this.type.includes(type)) return
      }

      this.searchMedia = false
      this.item = item
      this.setMedia()
    },

    dropItem: function ( $e ) {
      this.selectMedia(this.dragging)
      this.setDragging( undefined )
    },

    removeItem: function () {
      this.item = undefined
      this.setMedia()
    },

    setMedia: function () {
      this.$emit('setMedia', this.item)
    }
  },
  mounted() {
    this.item = this.media
  }
}
</script>
